module.exports = __webpack_public_path__ + "static/media/05.e82f9f6a.jpg";